import React from 'react';
import PropTypes from 'prop-types';

import LockableInput from './LockableInput';
import Icon from './icon';

const LockableInputWithIcon = ({
  className,
  disabled,
  hint,
  name,
  showIcon,
  type,
  placeholder,
  icon,
  ...props
}) => (
  <div className="lockable-input-with-icon u-position-relative">
    <LockableInput
      disabled={disabled}
      hint={hint}
      className={className}
      name={name}
      type={type}
      placeholder={placeholder}
      {...props}
    />
    {showIcon && <Icon glyph={icon} className="o-icon--small" />}
  </div>
);

LockableInputWithIcon.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hint: PropTypes.string.isRequired,
  icon: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
  showIcon: PropTypes.bool,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
};

LockableInputWithIcon.defaultProps = {
  className: '',
  disabled: false,
  showIcon: false,
};

export default LockableInputWithIcon;
